import React, { Suspense } from "react"
import { useLocation } from "@reach/router"
import dayjs from "dayjs"
//
import BackButton from "components/elements/link/backButton"
import Button from "@mui/material/Button"
import "styles/details.scss"
import "styles/gridGallery.scss"
import Skeleton from "react-loading-skeleton"

const GridDate = ({ start_date }) => {
    const location = useLocation()

    // show only for event with start_date
    if (!location.pathname?.includes("/events/") || !start_date) return null

    const day = dayjs(start_date).format("DD")
    const month = dayjs(start_date).format("MMM")
    const hour = dayjs(start_date).format("ha")

    return (
        <div className="event__date--wrapper">
            <span className="month">{month}</span>
            <h4 className="day">{day}</h4>
            <span className="time">{hour}</span>
        </div>
    )
}

const GridGalleryViewSkeleton = () => (
    <div>
        <div className="place__wrapper">
            <Skeleton />
            <Skeleton className="place__title" />
            <Skeleton className="place__name" />
        </div>

        <div className="image__gallery">
            <Skeleton className="image__gallery--item" />
            <Skeleton className="image__gallery--item" />
            <Skeleton className="image__gallery--item" />
            <Skeleton className="image__gallery--item" />
        </div>

        <div className="event__date--wrapper">
            <Skeleton className="month" />
            <Skeleton className="day" />
            <Skeleton className="time" />
        </div>

        <Skeleton className="view-more__btn vibe-pill" />
    </div>
)

const GridGalleryView = props => {
    const {
        openModal,
        onBack,
        name,
        placeLink,
        showBack = true,
        showCat = false,
        slug,
        start_date,
        category
    } = props

    const numberOfImages = props?.images?.length
    const galleryClass =
        numberOfImages > 3 ? "" : "image__gallery--" + numberOfImages

    const titleStyle = {
        display: "block",
        paddingTop: '0.4rem',
    }
    const catStyle = { fontSize: "1.4rem" }
    const suggestEditStyle = {
        float: "right",
        textDecoration: "none",
        margin: '1rem 0',
        right: '1.2rem' // TODO: if logged more offset
    }

    return (
        <Suspense fallback={<GridGalleryViewSkeleton />}>
            <div className="place__wrapper">
                {showBack && <BackButton onClick={onBack} />}

                <Button
                    variant="outlined"
                    href={`https://vibemap.com/edit-business?id=${slug}`}
                    style={suggestEditStyle} >
                    Suggest Edit
                </Button>

                <a className="pageLink" href={placeLink} style={titleStyle}>
                    {name && name.length > 2 ? (
                        <h1 className="place__name">{name}</h1>
                    ) : null}
                </a>
            </div>

            <div className={`image__gallery ${galleryClass}`}>
                {props?.images?.slice(0, 4)?.map((photo, key) => (
                    <img
                        className={"image__gallery--item"}
                        src={photo?.original}
                        key={key}
                    />
                ))}

                <GridDate start_date={start_date} />

                {numberOfImages > 3 ? (
                    <button className="button secondary small view-more__btn vibe-pill" onClick={openModal}>
                        View All ({numberOfImages})
                    </button>
                ) : null}
            </div>
        </Suspense>
    )
}

export default GridGalleryView